import './App.css';
import { Router, Route,Switch, Redirect } from 'react-router-dom';
import history from './history';
import GlobalStyles from './styles/globalStyle';
import NotFound from './components/notfound';
import Layout from './components/layout';
import MaintenancePage from './components/maintenance';
function App() {
  return (
    <Router history={history} >
      
      <GlobalStyles />
      <Switch>
        <Route path="/maintenance" component={MaintenancePage}/>
        <Route path="/404" component={NotFound}/>
        <Route path="/" component={Layout}/>
        <Redirect to="/404" />
      </Switch>
    </Router>
  );
}

export default App;
